// hooks/useGridwallRequestListData.ts
import { getCameraInstallationAnalytics } from '@api/services/analytics.service';
import { getAllGridWallRequests } from '@api/services/gridwall-request.service';
import useDataQuery from '@hooks/use-data-query';

const useGridwallRequestListData = () => {
    const query = useDataQuery(['grid-wall-request-list'], () => getAllGridWallRequests());

    const allData = query.data || [];

    return {
        gridwallRequests: allData,
        isLoading: query.isLoading,
    };
};

export default useGridwallRequestListData;
